import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import ContractTypeCreateForm from "./create";
import ContractTypeEditForm from "./edit";
import {
  getContractTypeDetails,
  getContractTypes,
} from "src/store/contract-type/saga";
import {
  ContractTypeDetailDto,
  ContractTypeDto,
} from "src/store/contract-type/type";
const ContractTypeesPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<ContractTypeDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ContractTypeDetailDto>();
  const columns = [
    {
      text: t("Contract.Type.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.Type.PageTitle")}
        metaTag={t("Contract.Type.MetaTag")}
        gridProps={{
          addTitle: t("Contract.Type.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getContractTypes,
          //  onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getContractTypeDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          // deleteButton: {
          //   text: (id, data: SectorDto) =>
          //     t("Contract.Type.DeleteQA", {
          //       name: data.Name,
          //     }),
          //   action: deleteSectorSaga,
          //   onClick: (id, data) => setShowEdit(data),
          // },
        }}
      />
      <ContractTypeCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getContractTypes,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ContractTypeEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getContractTypes,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ContractTypeesPage;
